<template>
  <label
    ref="label"
    for="file"
    class="text-base focus:shadow-outline"
    tabindex="0"
    >⬆ Upload CSV
    <input
      id="file"
      type="file"
      accept="text/csv"
      hidden
      @change="$emit('change', $event)"
    />
  </label>
</template>
<script>
export default {
  methods: {
    click() {
      this.$refs.label.click()
    },
  },
}
</script>
